import { EncodingOperationConfig } from 'core/shared/RemoteOperation'
import { EncodingPageLayout } from 'core/types'
import { EncodingExtensions } from 'stylewhere/extensions'
import { __, T } from 'stylewhere/shared/i18n'

export * from 'core/shared/utils'

export const getEncodingProductFields = () => {
  return EncodingExtensions.getOverrideProductInfoFields('encodingForm', null)
}

export const isEncodingErrorCheckingByRole = () => true

export const showCountersOnEncodingVerify = (initialType: string, operation: EncodingOperationConfig) =>
  ['order', 'orderRow'].includes(initialType)

export const canKillToAssociateItem = () => true

export const getEncodingPageLayout = (): EncodingPageLayout => {
  return {
    sideBarWidth: 530,
    productTitleStyle: {
      mb: '0'
    },
    productBoxPaddingCard: '10px 20px 10px 20px',
    productImage: {
      width: 200,
      height: 200,
      maxHeightContainer: 260
    }
  }
}

export const DEFAULT_PRODUCT_ATTRIBUTES = 4
